import { useCallback, useMemo } from 'react';
import I18n from 'I18n';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import partial from 'react-utils/partial';
// @ts-expect-error no defined types
import TimePickerButton from 'MeetingsLib/components/schedule/time/TimePickerButton';
// @ts-expect-error no defined types
import TimezoneSelect from 'MeetingsLib/components/schedule/time/TimezoneSelect';
// @ts-expect-error no defined types
import ZeroState from 'MeetingsLib/components/schedule/ZeroState';
// @ts-expect-error no defined types
import { getEvent as getEventSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { getAvailableStartTimesForSelectedDate as getAvailableStartTimesForSelectedDateSelector
// @ts-expect-error no defined types
} from 'MeetingsLib/selectors/AvailabilitySelectors';
// @ts-expect-error no defined types
import { getIsFetchingPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
import { isTroubleshootingSelector, getTroubleshootStartTimesForSelectedDate
// @ts-expect-error no defined types
} from 'MeetingsLib/selectors/TroubleshootingSelectors';
import { useAvailableTimesForSelectedDate } from '../../../context/PublicAvailabilityInfoContext';
// @ts-expect-error no defined types
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import isEmpty from 'transmute/isEmpty';
import H5 from 'UIComponents/elements/headings/H5';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimePicker({
  branding,
  compact,
  profile,
  availableStartTimeOptions,
  duration,
  selectedTime,
  setEventDateTime,
  setTimezone,
  troubleshootStartTimes,
  userTimezone,
  isTroubleshooting,
  TimePickerMarker,
  selectedDate,
  isRescheduling
}) {
  const availableStartTimesFromContext = useAvailableTimesForSelectedDate();
  const sortedStartTimeOptions = useMemo(() => {
    const startTimesOptions = availableStartTimesFromContext.size ? availableStartTimesFromContext : availableStartTimeOptions;
    return startTimesOptions.sort();
  }, [availableStartTimeOptions, availableStartTimesFromContext]);
  const getClassNames = useCallback(() => {
    return "time-picker flex-column width-100 p-x-8 " + (compact ? "compact m-top-4" : 'm-y-8');
  }, [compact]);
  const getTimeRangeValueLabel = useCallback(time => {
    return I18n.moment(time).tz(userTimezone).format('LT');
  }, [userTimezone]);
  const handleSetEventDateTime = useCallback(time => {
    return partial(setEventDateTime, time);
  }, [setEventDateTime]);
  const shouldShowNoTimesMessage = useMemo(() => {
    if (isTroubleshooting) {
      return isEmpty(troubleshootStartTimes);
    }
    return availableStartTimeOptions.count() === 0;
  }, [availableStartTimeOptions, isTroubleshooting, troubleshootStartTimes]);
  const renderedTroubleshootTimeButtons = useMemo(() => {
    return troubleshootStartTimes.map(troubleshootStartTime => {
      const {
        conflictingEvents: [conflictingEvent = {}]
      } = troubleshootStartTime;
      return /*#__PURE__*/_jsx(TimePickerButton, {
        branding: branding,
        disabled: !troubleshootStartTime.available,
        selectedTime: selectedTime,
        time: troubleshootStartTime.startMillisUtc,
        unavailableReason: troubleshootStartTime.reason,
        userTimezone: userTimezone,
        handleSetEventDateTime: handleSetEventDateTime(troubleshootStartTime.startMillisUtc),
        conflictingEvent: conflictingEvent,
        selectedDate: selectedDate
      }, troubleshootStartTime.startMillisUtc);
    });
  }, [branding, handleSetEventDateTime, selectedDate, selectedTime, troubleshootStartTimes, userTimezone]);
  const renderTimePickerButtons = useMemo(() => {
    return sortedStartTimeOptions.map(time => {
      return /*#__PURE__*/_jsx(TimePickerButton, {
        disabled: false,
        branding: branding,
        handleSetEventDateTime: handleSetEventDateTime(time),
        selectedTime: selectedTime,
        time: time,
        userTimezone: userTimezone,
        selectedDate: selectedDate
      }, time);
    });
  }, [sortedStartTimeOptions, branding, handleSetEventDateTime, selectedDate, selectedTime, userTimezone]);
  const renderedInputs = useMemo(() => {
    const buttons = isTroubleshooting ? renderedTroubleshootTimeButtons : renderTimePickerButtons;
    const maxVal = getTimeRangeValueLabel(sortedStartTimeOptions.last());
    const minVal = getTimeRangeValueLabel(sortedStartTimeOptions.first());
    return /*#__PURE__*/_jsxs("div", {
      role: "region",
      "aria-labelledby": "available-times",
      id: "available-times-region",
      "aria-controls": "meeting-confirmation-form",
      className: "time-list-container p-x-1 overflow-y-auto",
      "aria-valuetext": `From ${minVal} to ${maxVal}`,
      children: [buttons, /*#__PURE__*/_jsx(TimePickerMarker, {})]
    });
  }, [TimePickerMarker, getTimeRangeValueLabel, isTroubleshooting, renderTimePickerButtons, renderedTroubleshootTimeButtons, sortedStartTimeOptions]);
  const renderedTimezoneSelect = useMemo(() => {
    return /*#__PURE__*/_jsx(TimezoneSelect, {
      style: {
        width: 'auto'
      },
      setTimezone: setTimezone,
      userTimezone: userTimezone,
      branding: branding,
      placement: "bottom"
    });
  }, [branding, setTimezone, userTimezone]);
  if (!duration) {
    return null;
  }
  if (shouldShowNoTimesMessage) {
    return /*#__PURE__*/_jsx("div", {
      className: "align-center height-100 p-x-10",
      children: /*#__PURE__*/_jsx(ZeroState, {
        profile: profile,
        TimePickerMarker: TimePickerMarker
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: getClassNames(),
    "data-test-id": "time-options",
    children: [/*#__PURE__*/_jsx(H5, {
      "aria-level": 2,
      className: "m-bottom-1",
      id: "available-times",
      children: isRescheduling ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.timePicker.rescheduleHeader"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.timePicker.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      style: {
        fontSize: 'medium'
      },
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "prebook.timePicker.headerDate",
        options: {
          currentDate: I18n.moment(selectedDate).format('LL')
        }
      })
    }), renderedTimezoneSelect, renderedInputs]
  });
}
const mapStateToProps = state => ({
  activeLocale: state.activeLocale,
  troubleshootStartTimes: getTroubleshootStartTimesForSelectedDate(state),
  isTroubleshooting: isTroubleshootingSelector(state),
  availableStartTimeOptions: getAvailableStartTimesForSelectedDateSelector(state),
  duration: getEventSelector(state).duration,
  isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
  selectedTime: getEventSelector(state).dateTime,
  selectedDate: getEventSelector(state).dateString,
  userTimezone: state.userTimezone,
  isRescheduling: state.isRescheduling
});
export default connect(mapStateToProps, Object.assign({}, FormActions))(TimePicker);